import { NgModule } from "@angular/core";
import { LibAuthService as MatAuthService } from 'ngx-mat-auth';
import { LibDocumentModuleConfig, LibReleaseNoteModuleConfig, NgxAuditModule, NgxButtonsModule, NgxDialogModule, NgxDocumentModule, NgxGridModule, NgxInputsModule, NgxLayoutModule, NgxListDetailModule, NgxNoteModule, NgxNotificationModule, NgxProgressModule, NgxReleaseNoteModule, NgxSearchModule } from 'ngx-mat-base-comp';
import { environment } from "src/environments/environment";
import { DocumentService } from "./document/document.service";

const documentModuleConfig: LibDocumentModuleConfig = {urlUploadFile: '', requestService: null, actionDownloadFile: '', 
  actionDeleteFile: '', backendAccessToken: ''}

  const releaseNoteModuleConfig: LibReleaseNoteModuleConfig = {
    baseURLApi: environment.baseURLHubAPI,
    systemId: -1, // by module
    isHistoryByModule: true,
    releaseNotesURL: '/release-notes'
  };

@NgModule({
  imports: [
    NgxDocumentModule.forRoot(documentModuleConfig),
    NgxNoteModule,
    NgxDialogModule,
    NgxReleaseNoteModule.forRoot(releaseNoteModuleConfig)
  ],
  exports: [
    NgxGridModule,
    NgxNotificationModule,
    NgxDocumentModule,
    NgxNoteModule,
    NgxDialogModule,
    NgxButtonsModule,
    NgxInputsModule,
    NgxProgressModule,
    NgxSearchModule,
    NgxAuditModule,
    NgxLayoutModule,
    NgxListDetailModule,
  ]
  })
export class LibBaseComponentModule { 
  constructor(documentService: DocumentService, libMatAuthService: MatAuthService,) {

    documentModuleConfig.urlUploadFile =  environment.baseURLHubAPI + '/Document/UploadFile';
    documentModuleConfig.requestService = documentService;
    documentModuleConfig.actionDownloadFile = 'download';
    documentModuleConfig.actionDeleteFile = 'deleteFile';
    libMatAuthService.getAccessToken().then(result => documentModuleConfig.backendAccessToken = result);

    
  }
}



